/* RESPONSIBLE TEAM: team-fin-voice */
import type AppService from 'embercom/services/app-service';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';
import type RouterService from '@ember/routing/router-service';

export default class FinAIAgentSettingsPronunciationsRoute extends IntercomRoute {
  @service declare appService: AppService;
  @service declare intl: IntlService;
  @service declare finVoiceConfigService: FinVoiceConfigService;
  @service declare router: RouterService;

  analytics = {
    section: 'ai-chatbot',
    place: 'settings.pronunciations',
  };

  get titleToken(): string {
    return this.intl.t('ai-agent.voice-playground.pronunciations-title');
  }

  async beforeModel() {
    let canAccess = await this.finVoiceConfigService.canAccessFinVoice();
    if (!canAccess) {
      this.router.replaceWith('apps.app.automation.fin-ai-agent.settings.index');
    }
  }

  get app() {
    return this.appService.app;
  }
}
